export class GlobalResponseObject {
    status: boolean;
    statusCode?: number;
    intlCode: number;
    internalMessage: string;
}

